import React, { useEffect, useState } from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Theme,
} from "@mui/material";
import { Field } from "../../utils/formSchema";
import CustomInputButton from "../../components/Input/customInputButton";
import DamsTable from "../../components/Table/CollapsibleTable";
import { TRowItem } from "../../components/Table/TableRow";
import { useMangeTableItems } from "../../hooks/useManageTableItems";
import { usePagination } from "../../hooks/usePagination";
import { useDmsForm } from "../../hooks/useDmsFrom";

import { ContainedButton, TextButton } from "../../components/Button/AppButton";

import { FilterItemButton } from "../../components/Button/FilterItemButton";
import { GetUser, IPagination,  } from "../../config/types";
import { SideBarSearchInput } from "../../components/Layout/SideBarSearchInput";
import { formatSnakeCaseToReadable } from "../../utils/common";
import { FilterModal } from "../FilterModal";
import { UserCategorySelectInput } from "./UserCategorySelectInput";
import { UserApi } from "../../services/users";

interface InputProps {
  placeholder: string;
  label: string;
  handleChange: (item: Field,label?:string) => void;
  value?: string;
  size?: "full" | "short" | "long";
  error?: boolean;
  errorMessage?: string;
}

interface Ifilter {
  telephone: string;
  email: string;
  user_category_id: string;
}
export const UserSelectInput = ({
  placeholder,
  handleChange,
  label,
  error,
  value,
  size = "full",
  errorMessage = "required",
}: InputProps) => {
  const [dataset, setDataset] = useState<TRowItem[]>([]);
  const [selectName, setSelectName] = useState("");
  const [loading, setLoading] = useState(true);
  const { selectedRowItems, toggleRow } = useMangeTableItems(dataset, false);
  const [querySet, setQuerySet] = useState({ is_deleted: false });
  const {
    pagination,
    paginateToNextPage,
    paginateToPreviousPage,
    paginateToPageNumber,
    updatePaginationInitState,
  } = usePagination<any>(UserApi.listUsers);

  const { form, updateInputField, updateForm, onFormSubmit, getFormValues } =
    useDmsForm<Ifilter>({
      user_category_id: "",
      email: "",
      telephone: "",
    });

  const populateDataSet = (data: GetUser[], pagination?: IPagination) => {
    setDataset(data);
    updatePaginationInitState(pagination);
  };
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const res = await UserApi.listUsers({
        is_deleted: false,
      });
      if (res.data) {
        populateDataSet(res.data, res.pagination);
        if (value) {
          const __default = (await UserApi.getUserById(value))
            .data;
          if (__default) {
            setSelectName(`${__default.first_name} ${__default.last_name} `);
            handleChange({ value: __default.id, isValid: true },`${__default.first_name} ${__default.last_name} `);
            toggleRow(__default as TRowItem);
          }
        }
      }
      setLoading(false);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [open, setOpen] = React.useState(false);
  const toggleModel = () => {
    setOpen(!open);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const resetFilter = <K extends keyof Ifilter>(key: K) => {
    updateForm((p) => {
      const state = {
        ...p,
        [key]: { value: "" },
      };
      setQuerySet((prev) => ({ ...prev, [key]: "" }));
      return state;
    });
  };

  useEffect(() => {
    const { data } = onFormSubmit();
    setQuerySet((p) => ({ ...p, ...data }));

    const filterRequest = async () => {
      setLoading(true);
      const res = await UserApi.listUsers({
        is_deleted: false,
        ...data,
      });
      if (res.data) {
        populateDataSet(res.data, res.pagination);
      }
      setLoading(false);
    };
    filterRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.email.value, form.telephone.value, form.user_category_id.value]);

  const handleUserResponse = (row: TRowItem) => {
    const response = toggleRow(row);
    if (response && response.isSelected) {
      handleChange({
        value: row?.id ?? "",
        isValid: row?.id ? true : false,
      },`${row.first_name} ${row.last_name}`);
      setSelectName(  `${row.first_name} ${row.last_name}`);
      handleClose();
    }
  };
  function handleCategorySelect(item: Field) {
    updateForm((p) => ({ ...p, user_category_id: item }));
  }

  return (
    <Box>
      <CustomInputButton
        loading={loading}
        label={label}
        placeholder={placeholder}
        value={selectName}
        handleChange={toggleModel}
        error={error}
        errorMessage={errorMessage}
        size={size}
      />
      <Dialog
        maxWidth={"xl"}
        open={open}
        sx={{ height: "100%" }}
        onClose={toggleModel}
      >
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          paddingRight={2}
        >
          <DialogTitle fontWeight={600}>{"User List"}</DialogTitle>
          {value === "" ? (
            <Box marginTop={2}>
              <TextButton title="Continue" />
            </Box>
          ) : (
            <DialogActions>
              <ContainedButton onClick={handleClose} title="Continue" />
            </DialogActions>
          )}
        </Stack>

        <DialogContent sx={styles.content}>
          <Box sx={styles.filterBox}>
            <Stack width={'100%'} direction={'row'} justifyContent={'space-between'}>

            <Stack direction={"row"} spacing={2}>
              <FilterModal
                label="Filters"
                loading={loading}
                closeOnoutSideClick
              >
                <Stack direction={"column"} spacing={2}>
                <UserCategorySelectInput
                              label="User Category"
                              placeholder="Select User Category"
                              handleChange={handleCategorySelect}
                              value={form.user_category_id.value}
                            />
                  <SideBarSearchInput
                    label="Telephone"
                    placeholder="Search by telephone line ..."
                    value={form.telephone.value}
                    handleChange={updateInputField("telephone")}
                  />

             
                </Stack>
              
              </FilterModal>

              {Object.entries(getFormValues())
                .filter(
                  ([_, value]) =>
                    typeof value === "string" && value.trim() !== ""
                )
                .map(([key, value]) => (
                  <FilterItemButton
                    key={key}
                    label={formatSnakeCaseToReadable(key)}
                    tip={value}
                    height={40}
                    onClick={() => resetFilter(key as keyof Ifilter)}
                  />
                ))}
              
            </Stack>
            
            <SideBarSearchInput
                    placeholder="Search by email address ..."
                    value={form.email.value}
                    handleChange={updateInputField("email")}
                  />
            </Stack>
          </Box>

          <DamsTable
            isModel
            tableHeaders={columns}
            hiddenKeys={hkeys}
            hiddenLabels={hcolumns}
            tableKeys={tkeys}
            data={dataset}
            hasHeaderCheckBox={false}
            hasPagination
            paginationState={pagination}
            onNextPage={paginateToNextPage(querySet, populateDataSet)}
            onPreviousPage={paginateToPreviousPage(querySet, populateDataSet)}
            setActivePage={paginateToPageNumber(populateDataSet, querySet)}
            useTableCheckbox
            onTableItemSelect={handleUserResponse}
            selectedRowItems={selectedRowItems}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

const styles = {
  filterBox: {
    width: "100%",
    marginBottom: 5,
  },
  content: (theme: Theme) => ({
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    [theme.breakpoints.up("xl")]: {
      width: "70vw",
    },
    width: "90vw",
  }),
  table: {
    width: "100vw",
    height: "70%",
  },
};

const tkeys = [
  "first_name",
  "last_name",
  "user_domain",
  "role",
  "created_at",
  "is_active"
];

const columns = [
  "First Name",
  "Last Name",
  "Domain",
  "Role",
  "Date Added",
  "Status"
];

const hkeys = ["email", "telephone"];

const hcolumns = ["Email", "Telephone"];
